// extracted by mini-css-extract-plugin
export default {"App":"Privacy_App__e7o1-","Main":"Privacy_Main__CKRih","privacySection":"Privacy_privacySection__27sGd","App-footer":"Privacy_App-footer__HFlR7"};